import(/* webpackMode: "eager" */ "/app/app/strategies/page.tsx");
